import {
  GLOBAL_PROCESSING_COMPLETED,
  GLOBAL_PROCESSING_FAILED,
  GLOBAL_PROCESSING_PENDING,
  GLOBAL_PROCESSING_PROCESSING,
  isGlobalProcessingState,
  type GlobalProcessingState,
} from "@constructionautomation/backend/convex/lib/processingStates";

export {
  GLOBAL_PROCESSING_COMPLETED,
  GLOBAL_PROCESSING_FAILED,
  GLOBAL_PROCESSING_PENDING,
  GLOBAL_PROCESSING_PROCESSING,
  isGlobalProcessingState,
};

export type { GlobalProcessingState };

export type ProcessingStateWithIdle = GlobalProcessingState | "idle";

export function toProcessingStateWithIdle(value: unknown): ProcessingStateWithIdle {
  if (!isGlobalProcessingState(value)) {
    return "idle";
  }
  return value;
}
